import React from "react";
//#region redux
//#endregion
//#region types
import { IconDefinitionConstants } from "utils/constants";
import { NumberRangeProps } from "models/propTypes/commonPropTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
import Icon from "./icon";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const NumberRange: React.FC<NumberRangeProps> = (props) => {
  return props.lowest !== undefined ? (
    <Grid container spacing={1} alignItems="center" className={cssExports.dateRange}>
      <Grid item>
        {props.currencyCode
          ? LocalizationHelperInstance.getFormattedCurrency(props.lowest, props.currencyCode)
          : LocalizationHelperInstance.getFormattedNumber(props.lowest)}
      </Grid>
      {props.highest !== undefined && (
        <>
          <Grid item>
            <Icon icon={props.separatorIcon ? props.separatorIcon : IconDefinitionConstants.WArrowSmallRight} />
          </Grid>
          <Grid item>
            {props.currencyCode
              ? LocalizationHelperInstance.getFormattedCurrency(props.highest, props.currencyCode)
              : LocalizationHelperInstance.getFormattedNumber(props.highest)}
          </Grid>
        </>
      )}
    </Grid>
  ) : (
    <></>
  );
};

export default NumberRange;
